module.exports = __webpack_public_path__ + "img/marker_selected_focused.ee3d95be.svg";